import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

interface MatchFoundStore {
    isMatchFound: boolean;
    setMatchFound: (val: boolean) => void;
}

export const useMatchFound = create<MatchFoundStore>()(
    devtools(
        immer((set, get) => ({
            isMatchFound: false,
            setMatchFound: (val: boolean) => {
                set({ isMatchFound: val });
            }
        })),
    ),
);
